import React from "react";
import { Redirect, Switch, useLocation } from "react-router-dom";

import PageLayout from "../components/Layout/PageLayout";
import { PromoState } from "../context";
import { Promo } from "../views";
import PromoWrite from "../views/Promo/PromoWrite";
import PermissionedRoute from "./PermissionedRoute";
import Permissions from "../permissions";
import PromoGroupWrite from "../views/Promo/PromoGroupWrite";
import { accessTokenCookieKey, getCookies, refreshTokenCookieKey } from "../API/cookies";

export const PromosRouter = () => {
  const location = useLocation();
  const background = location?.state?.background || location;

  if (!getCookies(accessTokenCookieKey) && !getCookies(refreshTokenCookieKey))
    return <Redirect to={{ pathname: "/logout", state: { from: location.pathname } }} />;
  return (
    <>
      <Switch location={background || location}>
        <PermissionedRoute
          permission={Permissions.readPromos}
          path={["/promos", "/promo-groups", "/promo-groups/:promoGroupId"]}
        >
          <PageLayout>
            <PromoState>
              <Promo />
            </PromoState>
          </PageLayout>
        </PermissionedRoute>
      </Switch>
      {/* modals */}
      {background && (
        <Switch>
          <PermissionedRoute
            permission={[Permissions.readPromos, Permissions.writePromos]}
            path="/promos/new"
          >
            <PromoWrite />
          </PermissionedRoute>
          <PermissionedRoute
            permission={[Permissions.readPromos, Permissions.writePromos]}
            path="/promo-groups/new"
          >
            <PromoGroupWrite />
          </PermissionedRoute>
          <PermissionedRoute
            permission={[Permissions.readPromos, Permissions.writePromos]}
            path="/promo-groups/:promoGroupId/edit"
          >
            <PromoGroupWrite />
          </PermissionedRoute>
        </Switch>
      )}
    </>
  );
};

export default PromosRouter;
